export default __webpack_public_path__ + "static/media/camara.d02b94bf.svg";